import { Networks } from "~/schema";

// // // //

export const EXPLORERS: { [key in Networks]: string } = {
    [Networks.algorand]: "https://allo.info/",
    [Networks.arbitrum]: "https://arbiscan.io/",
    [Networks.avalanche]: "https://snowtrace.io/",
    [Networks.base]: "https://basescan.org/",
    [Networks.bnbChain]: "https://bscscan.com/",
    [Networks.bitcoin]: "",
    [Networks.blast]: "https://blastscan.io/",
    [Networks.canto]: "https://cantoscan.com/",
    [Networks.canton]: "https://www.cantonscan.com/",
    [Networks.celo]: "https://celoscan.io/",
    [Networks.eos]: "",
    [Networks.ethereum]: "https://etherscan.io/",
    [Networks.ethereumClassic]: "",
    [Networks.flow]: "",
    [Networks.gnosis]: "https://gnosisscan.io/",
    [Networks.hedera]: "https://hashscan.io/mainnet/",
    [Networks.hyperEVM]: "https://hyperevmscan.io/",
    [Networks.injective]: "https://injscan.com/",
    [Networks.ink]: "https://explorer.inkonchain.com/",
    [Networks.kava]: "",
    [Networks.liquid]: "https://liquid.network/",
    [Networks.mantle]: "https://explorer.mantle.xyz/",
    [Networks.mantra]: "https://www.mintscan.io/mantra/",
    [Networks.monad]: "https://monadscan.com/",
    [Networks.near]: "https://nearblocks.io/",
    [Networks.noble]: "https://www.mintscan.io/noble/",
    [Networks.optimism]: "https://optimistic.etherscan.io/",
    [Networks.pharos]: "https://www.pharosscan.xyz/",
    [Networks.plasma]: "https://plasmascan.to/",
    [Networks.polkadot]: "",
    [Networks.polygon]: "https://polygonscan.com/",
    [Networks.PolygonzkEVM]: "",
    [Networks.provenance]: "https://explorer.provenance.io/",
    [Networks.robinhoodChain]: "https://robinhoodchain.blockscout.com/",
    [Networks.rootstock]: "https://explorer.rootstock.io/",
    [Networks.plume]: "https://explorer.plume.org/",
    [Networks.solana]: "https://solscan.io/",
    [Networks.stellar]: "https://stellar.expert/",
    [Networks.tempo]: "https://explore.tempo.xyz/",
    [Networks.tezos]: "",
    [Networks.tron]: "https://tronscan.org/#/",
    [Networks.xdc]: "https://xdcscan.com/",
    [Networks.sui]: "https://suiscan.xyz/mainnet/",
    [Networks.sei]: "https://seiscan.io/",
    [Networks.aptos]: "https://aptoscan.com/",
    [Networks.zksyncEra]: "https://explorer.zksync.io/",
    [Networks.xrpLedger]: "https://livenet.xrpl.org/",
};

export const EXPLORER_NAMES: { [key in Networks]: string } = {
    [Networks.algorand]: "Allo",
    [Networks.arbitrum]: "Arbiscan",
    [Networks.avalanche]: "Snowtrace",
    [Networks.base]: "BaseScan",
    [Networks.bnbChain]: "BscScan",
    [Networks.bitcoin]: "",
    [Networks.blast]: "Blastscan",
    [Networks.canto]: "Cantoscan",
    [Networks.canton]: "Cantonscan",
    [Networks.celo]: "CeloScan",
    [Networks.eos]: "",
    [Networks.ethereum]: "Etherscan",
    [Networks.ethereumClassic]: "",
    [Networks.flow]: "",
    [Networks.gnosis]: "GnosisScan",
    [Networks.hedera]: "HashScan",
    [Networks.hyperEVM]: "HyperEVMScan",
    [Networks.injective]: "Injective Explorer",
    [Networks.kava]: "",
    [Networks.ink]: "Ink Explorer",
    [Networks.liquid]: "Liquid Network",
    [Networks.mantle]: "Mantle Explorer",
    [Networks.mantra]: "Mintscan",
    [Networks.monad]: "MonadScan",
    [Networks.near]: "NEAR Blocks",
    [Networks.noble]: "Mintscan",
    [Networks.optimism]: "Etherscan",
    [Networks.pharos]: "Pharosscan",
    [Networks.plasma]: "Plasmascan",
    [Networks.polkadot]: "",
    [Networks.polygon]: "Polyscan",
    [Networks.plume]: "Plume Explorer",
    [Networks.PolygonzkEVM]: "",
    [Networks.provenance]: "Provenance Blockchain Explorer",
    [Networks.robinhoodChain]: "Robinhood Chain Blockscout",
    [Networks.rootstock]: "Rootstock Explorer",
    [Networks.solana]: "Solscan",
    [Networks.stellar]: "Stellar Expert",
    [Networks.tempo]: "Tempo Explorer",
    [Networks.tezos]: "",
    [Networks.tron]: "Tronscan",
    [Networks.xdc]: "BlocksScan",
    [Networks.xrpLedger]: "XRPL Explorer",
    [Networks.sui]: "suiscan",
    [Networks.sei]: "SeiScan",
    [Networks.aptos]: "Aptoscan",
    [Networks.zksyncEra]: "ZkSync Explorer",
};

// // // //

function getStellarExplorerUrl(props: {
    address: string;
    type: "address" | "tx" | "token";
}) {
    const { address, type } = props;
    const explorer = EXPLORERS[Networks.stellar];

    const path =
        type === "address"
            ? "explorer/public/account/"
            : type === "tx"
              ? "explorer/public/tx/"
              : type === "token"
                ? "explorer/public/asset/"
                : "";

    const href = `${explorer}${path}${address}`;
    return href;
}

function getEthereumExplorerUrl(props: {
    address: string;
    type: "address" | "tx" | "token";
}) {
    const { address, type } = props;
    const explorer = EXPLORERS[Networks.ethereum];

    const path =
        type === "address"
            ? "address/"
            : type === "tx"
              ? "tx/"
              : type === "token"
                ? "token/"
                : "";

    const href = `${explorer}${path}${address}`;
    return href;
}

function getSolanaExplorerUrl(props: {
    address: string;
    type: "address" | "tx" | "token";
}) {
    const { address, type } = props;
    const explorer = EXPLORERS[Networks.solana];

    const path =
        type === "address"
            ? "account/"
            : type === "tx"
              ? "tx/"
              : type === "token"
                ? "account/"
                : "";

    const href = `${explorer}${path}${address}`;
    return href;
}

function getPolygonExplorerUrl(props: {
    address: string;
    type: "address" | "tx" | "token";
}) {
    const { address, type } = props;
    const explorer = EXPLORERS[Networks.polygon];

    const path =
        type === "address"
            ? "address/"
            : type === "tx"
              ? "tx/"
              : type === "token"
                ? "token/"
                : "";

    const href = `${explorer}${path}${address}`;
    return href;
}

function getBscExplorerUrl(props: {
    address: string;
    type: "address" | "tx" | "token";
}) {
    const { address, type } = props;
    const explorer = EXPLORERS[Networks.bnbChain];

    const path =
        type === "address"
            ? "address/"
            : type === "tx"
              ? "tx/"
              : type === "token"
                ? "token/"
                : "";

    const href = `${explorer}${path}${address}`;
    return href;
}

function getTronExplorerUrl(props: {
    address: string;
    type: "address" | "tx" | "token";
}) {
    const { address, type } = props;
    const explorer = EXPLORERS[Networks.tron];

    const path =
        type === "address"
            ? "address/"
            : type === "tx"
              ? "transaction/"
              : type === "token"
                ? "token20/"
                : "";

    const href = `${explorer}${path}${address}`;
    return href;
}

function getXdcExplorerUrl(props: {
    address: string;
    type: "address" | "tx" | "token";
}) {
    const { address, type } = props;
    const explorer = EXPLORERS[Networks.xdc];

    const path =
        type === "address"
            ? "address/"
            : type === "tx"
              ? "txs/"
              : type === "token"
                ? "token/"
                : "";

    const href = `${explorer}${path}${address}`;
    return href;
}

function getCantoExplorerUrl(props: {
    address: string;
    type: "address" | "tx" | "token";
}) {
    const { address, type } = props;
    const explorer = EXPLORERS[Networks.canto];

    const path =
        type === "address"
            ? "address/"
            : type === "tx"
              ? "tx/"
              : type === "token"
                ? "address/"
                : "";

    const href = `${explorer}${path}${address}`;
    return href;
}

function getBaseExplorerUrl(props: {
    address: string;
    type: "address" | "tx" | "token";
}) {
    const { address, type } = props;
    const explorer = EXPLORERS[Networks.base];

    const path =
        type === "address"
            ? "address/"
            : type === "tx"
              ? "tx/"
              : type === "token"
                ? "token/"
                : "";

    const href = `${explorer}${path}${address}`;
    return href;
}

function getArbitrumExplorerUrl(props: {
    address: string;
    type: "address" | "tx" | "token";
}) {
    const { address, type } = props;
    const explorer = EXPLORERS[Networks.arbitrum];

    const path =
        type === "address"
            ? "address/"
            : type === "tx"
              ? "tx/"
              : type === "token"
                ? "token/"
                : "";

    const href = `${explorer}${path}${address}`;
    return href;
}

function getAlgorandExplorerUrl(props: {
    address: string;
    type: "address" | "tx" | "token";
}) {
    const { address, type } = props;
    const explorer = EXPLORERS[Networks.algorand];

    const path =
        type === "address"
            ? "account/"
            : type === "tx"
              ? "tx/"
              : type === "token"
                ? "asset/"
                : "";

    const href = `${explorer}${path}${address}`;
    return href;
}

function getOptimismExplorerUrl(props: {
    address: string;
    type: "address" | "tx" | "token";
}) {
    const { address, type } = props;
    const explorer = EXPLORERS[Networks.optimism];

    const path =
        type === "address"
            ? "address/"
            : type === "tx"
              ? "tx/"
              : type === "token"
                ? "token/"
                : "";

    const href = `${explorer}${path}${address}`;
    return href;
}

function getNobleExplorerUrl(props: {
    address: string;
    type: "address" | "tx" | "token";
}) {
    const { address, type } = props;
    const explorer = EXPLORERS[Networks.noble];

    const path =
        type === "address"
            ? "address/"
            : type === "tx"
              ? "tx/"
              : type === "token"
                ? "token/"
                : "";

    const href = `${explorer}${path}${address}`;
    return href;
}

function getProvenanceExplorerUrl(props: {
    address: string;
    type: "address" | "tx" | "token";
}) {
    const { address, type } = props;
    const explorer = EXPLORERS[Networks.provenance];

    const path =
        type === "address"
            ? "accounts/"
            : type === "tx"
              ? "tx/"
              : type === "token"
                ? "asset/"
                : "";

    const href = `${explorer}${path}${address}`;
    return href;
}

function getInkExplorerUrl(props: {
    address: string;
    type: "address" | "tx" | "token";
}) {
    const { address, type } = props;
    const explorer = EXPLORERS[Networks.ink];

    const path =
        type === "address"
            ? "address/"
            : type === "tx"
              ? "tx/"
              : type === "token"
                ? "token/"
                : "";

    const href = `${explorer}${path}${address}`;
    return href;
}

function getRootstockExplorerUrl(props: {
    address: string;
    type: "address" | "tx" | "token";
}) {
    const { address, type } = props;
    const explorer = EXPLORERS[Networks.rootstock];

    const path =
        type === "address"
            ? "addresses/"
            : type === "tx"
              ? "txs/"
              : type === "token"
                ? "token/"
                : "";

    const href = `${explorer}${path}${address}`;
    return href;
}

function getRobinhoodChainExplorerUrl(props: {
    address: string;
    type: "address" | "tx" | "token";
}) {
    const { address, type } = props;
    const explorer = EXPLORERS[Networks.robinhoodChain];

    const path =
        type === "address"
            ? "address/"
            : type === "tx"
              ? "tx/"
              : type === "token"
                ? "token/"
                : "";

    const href = `${explorer}${path}${address}`;
    return href;
}

function getAvalancheExplorerUrl(props: {
    address: string;
    type: "address" | "tx" | "token";
}) {
    const { address, type } = props;
    const explorer = EXPLORERS[Networks.avalanche];

    const path =
        type === "address"
            ? "address/"
            : type === "tx"
              ? "tx/"
              : type === "token"
                ? "token/"
                : "";

    const href = `${explorer}${path}${address}`;
    return href;
}

function getNearExplorerUrl(props: {
    address: string;
    type: "address" | "tx" | "token";
}) {
    const { address, type } = props;
    const explorer = EXPLORERS[Networks.near];

    const path =
        type === "address"
            ? "address/"
            : type === "tx"
              ? "txns/"
              : type === "token"
                ? "token/"
                : "";

    const href = `${explorer}${path}${address}`;
    return href;
}

function getMantleExplorerUrl(props: {
    address: string;
    type: "address" | "tx" | "token";
}) {
    const { address, type } = props;
    const explorer = EXPLORERS[Networks.mantle];

    const path =
        type === "address"
            ? "address/"
            : type === "tx"
              ? "tx/"
              : type === "token"
                ? "token/"
                : "";

    const href = `${explorer}${path}${address}`;
    return href;
}

function getBlastExplorerUrl(props: {
    address: string;
    type: "address" | "tx" | "token";
}) {
    const { address, type } = props;
    const explorer = EXPLORERS[Networks.blast];

    const path =
        type === "address"
            ? "address/"
            : type === "tx"
              ? "tx/"
              : type === "token"
                ? "token/"
                : "";

    const href = `${explorer}${path}${address}`;
    return href;
}

function getGnosisExplorerUrl(props: {
    address: string;
    type: "address" | "tx" | "token";
}) {
    const { address, type } = props;
    const explorer = EXPLORERS[Networks.gnosis];

    const path =
        type === "address"
            ? "address/"
            : type === "tx"
              ? "tx/"
              : type === "token"
                ? "token/"
                : "";

    const href = `${explorer}${path}${address}`;
    return href;
}

function getCeloExplorerUrl(props: {
    address: string;
    type: "address" | "tx" | "token";
}) {
    const { address, type } = props;
    const explorer = EXPLORERS[Networks.celo];

    const path =
        type === "address"
            ? "address/"
            : type === "tx"
              ? "tx/"
              : type === "token"
                ? "token/"
                : "";

    const href = `${explorer}${path}${address}`;
    return href;
}

function getAptosExplorerUrl(props: {
    address: string;
    type: "address" | "tx" | "token";
}) {
    const { address, type } = props;
    const explorer = EXPLORERS[Networks.aptos];

    // NOTE - this is a hack to fix the fact that Aptos Explorer is case sensitive
    // This was addded on 11/8/24 - it can probably be removed once we fix the case-sensitiving in the data lake
    const addressValue = address?.endsWith("::usdy::usdy")
        ? address.replace("::usdy::usdy", "::usdy::USDY")
        : address;

    // Check if address contains two pairs of "::" substrings
    // If not, we'll direct users with the `/fungible-asset/` path
    const isCoin = (addressValue?.match(/::/g) || []).length === 2;

    const path =
        type === "address"
            ? "account/"
            : type === "tx"
              ? "transaction/"
              : type === "token"
                ? isCoin
                    ? "coin/"
                    : "fungible-asset/"
                : "";

    const href = `${explorer}${path}${addressValue}`;
    return href;
}

function getSuiExplorerUrl(props: {
    address: string;
    type: "address" | "tx" | "token";
}) {
    const { address, type } = props;
    const explorer = EXPLORERS[Networks.sui];

    const path =
        type === "address"
            ? "account/"
            : type === "tx"
              ? "tx/"
              : type === "token"
                ? "coin/"
                : "";

    const href = `${explorer}${path}${address}`;
    return href;
}

// // // //

function getSeiExplorerUrl(props: {
    address: string;
    type: "address" | "tx" | "token";
}) {
    const { address, type } = props;
    const explorer = EXPLORERS[Networks.sei];

    const path =
        type === "address"
            ? "address/"
            : type === "tx"
              ? "tx/"
              : type === "token"
                ? "token/"
                : "";

    const href = `${explorer}${path}${address}`;
    return href;
}

// // // //

function getZkSyncExplorerUrl(props: {
    address: string;
    type: "address" | "tx" | "token";
}) {
    const { address, type } = props;
    const explorer = EXPLORERS[Networks.zksyncEra];

    const path =
        type === "address"
            ? "address/"
            : type === "tx"
              ? "tx/"
              : type === "token"
                ? "address/"
                : "";

    const href = `${explorer}${path}${address}`;
    return href;
}

// // // //

function getMantraExplorerUrl(props: {
    address: string;
    type: "address" | "tx" | "token";
}) {
    const { address, type } = props;
    const explorer = EXPLORERS[Networks.mantra];

    // Return null if there's no address or network present
    if (address === null) {
        return null;
    }

    // Base path based on type
    let path =
        type === "address"
            ? "assets/"
            : type === "tx"
              ? "tx/"
              : type === "token"
                ? "assets/"
                : "";

    // Handle transaction URLs
    // NOTE - transaction URLs don't use the encoded address
    if (type === "tx") {
        return `${explorer}${path}${address}`;
    }

    // Base64 encode the address for token URLs
    const encodedAddress = btoa(address || "");

    // Handle non ICS20 tokens - default to cw20
    // NOTE - we may need to add a check for token standard here, which would require updating all the getBlockchainExplorerUrl code
    // Might make sense to do this in the datalake or in dbt?
    if (!address.includes("ibc/")) {
        return `${explorer}${path}cw20/${encodedAddress}`;
    }

    // NOTE - this URL works ONLY for ICS20 tokens
    return `${explorer}${path}ibc/${encodedAddress}`;
}

function getMonadExplorerUrl(props: {
    address: string;
    type: "address" | "tx" | "token";
}) {
    const { address, type } = props;
    const explorer = EXPLORERS[Networks.monad];

    const path =
        type === "address"
            ? "address/"
            : type === "tx"
              ? "tx/"
              : type === "token"
                ? "token/"
                : "";

    const href = `${explorer}${path}${address}`;
    return href;
}

// // // //

function getXrpLedgerCurrencyCode(currencyCode: string) {
    if (/^[A-Fa-f0-9]{40}$/.test(currencyCode)) {
        return currencyCode.toUpperCase();
    }

    if (currencyCode.length === 3) {
        return currencyCode;
    }

    const encodedCurrencyCode = currencyCode
        .split("")
        .map((char) =>
            char.charCodeAt(0).toString(16).toUpperCase().padStart(2, "0"),
        )
        .join("")
        .padEnd(40, "0")
        .slice(0, 40);

    return encodedCurrencyCode;
}

function getXrpLedgerTokenAddress(address: string) {
    const delimiterIndex = address.indexOf(".");

    if (delimiterIndex < 1) {
        return address;
    }

    const currencyCode = address.slice(0, delimiterIndex);
    const issuerAddress = address.slice(delimiterIndex + 1);

    if (!issuerAddress) {
        return address;
    }

    const formattedCurrencyCode = getXrpLedgerCurrencyCode(currencyCode);
    return `${formattedCurrencyCode}.${issuerAddress}`;
}

// // // //

function getXrpLedgerExplorerUrl(props: {
    address: string;
    type: "address" | "tx" | "token";
}) {
    const { address, type } = props;
    const explorer = EXPLORERS[Networks.xrpLedger];

    // Handle different types of explorer paths
    let path = "";
    if (type === "address") {
        path = "accounts/";
    } else if (type === "tx") {
        path = "transactions/"; // Using full "transactions" path for clarity
    } else if (type === "token") {
        // Check if the address contains a currency code format (e.g., "USD.issuerAddress")
        if (address?.includes(".")) {
            path = "token/";
        } else {
            // If no dot notation, treat as an account address
            path = "accounts/";
        }
    }

    const formattedAddress =
        type === "token" && typeof address === "string" && address.includes(".")
            ? getXrpLedgerTokenAddress(address)
            : address;

    const href = `${explorer}${path}${formattedAddress}`;
    return href;
}

// // // //

function getPlumeExplorerUrl(props: {
    address: string;
    type: "address" | "tx" | "token";
}) {
    const { address, type } = props;
    const explorer = EXPLORERS[Networks.plume];

    const path =
        type === "address"
            ? "address/"
            : type === "tx"
              ? "tx/"
              : type === "token"
                ? "token/"
                : "";

    const href = `${explorer}${path}${address}`;
    return href;
}

function getHederaExplorerUrl(props: {
    address: string;
    type: "address" | "tx" | "token";
}) {
    const { address, type } = props;
    const explorer = EXPLORERS[Networks.hedera];

    const path =
        type === "address"
            ? "account/"
            : type === "tx"
              ? "transaction/"
              : type === "token"
                ? "token/"
                : "";

    const href = `${explorer}${path}${address}`;
    return href;
}

function getLiquidExplorerUrl(props: {
    address: string;
    type: "address" | "tx" | "token";
}) {
    const { address, type } = props;
    const explorer = EXPLORERS[Networks.liquid];

    const path =
        type === "address"
            ? "address/"
            : type === "tx"
              ? "tx/"
              : type === "token"
                ? "assets/asset/"
                : "";

    const href = `${explorer}${path}${address}`;
    return href;
}

function getHyperEvmExplorerUrl(props: {
    address: string;
    type: "address" | "tx" | "token";
}) {
    const { address, type } = props;
    const explorer = EXPLORERS[Networks.hyperEVM];

    const path =
        type === "address"
            ? "address/"
            : type === "tx"
              ? "tx/"
              : type === "token"
                ? "token/"
                : "";

    const href = `${explorer}${path}${address}`;
    return href;
}

function getInjectiveExplorerUrl(props: {
    address: string;
    type: "address" | "tx" | "token";
}) {
    const { address, type } = props;
    const explorer = EXPLORERS[Networks.injective];

    const path =
        type === "address"
            ? "account/"
            : type === "tx"
              ? "transaction/"
              : type === "token"
                ? "asset/"
                : "";

    const href = `${explorer}${path}${encodeURIComponent(address)}`;
    return href;
}

function getPlasmaExplorerUrl(props: {
    address: string;
    type: "address" | "tx" | "token";
}) {
    const { address, type } = props;
    const explorer = EXPLORERS[Networks.plasma];

    const path =
        type === "address"
            ? "address/"
            : type === "tx"
              ? "tx/"
              : type === "token"
                ? "token/"
                : "";

    const href = `${explorer}${path}${address}`;
    return href;
}

function getPharosExplorerUrl(props: {
    address: string;
    type: "address" | "tx" | "token";
}) {
    const { address, type } = props;
    const explorer = EXPLORERS[Networks.pharos];

    const path =
        type === "address"
            ? "address/"
            : type === "tx"
              ? "tx/"
              : type === "token"
                ? "token/"
                : "";

    const href = `${explorer}${path}${address}`;
    return href;
}

function getTempoExplorerUrl(props: {
    address: string;
    type: "address" | "tx" | "token";
}) {
    const { address, type } = props;
    const explorer = EXPLORERS[Networks.tempo];

    // NOTE - Tempo's explorer uses `receipt/` rather than the usual `tx/` for transactions
    const path =
        type === "address"
            ? "address/"
            : type === "tx"
              ? "receipt/"
              : type === "token"
                ? "token/"
                : "";

    const href = `${explorer}${path}${address}`;
    return href;
}

function getCantonExplorerUrl(props: {
    address: string;
    type: "address" | "tx" | "token";
}) {
    const { address, type } = props;
    const explorer = EXPLORERS[Networks.canton];

    if (address === null) {
        return null;
    }

    // NOTE - Cantonscan keys token pages by ticker (e.g. `/tokens/CUSD`), not by
    // address, so there's no way to build a token URL from an address alone.
    // Canton tokens currently have a null `address` in the data lake anyway.
    if (type === "token") {
        return null;
    }

    // Canton identifies accounts by party ID (e.g. `Cantex::1220a820...`), which
    // must be URL-encoded because of the `::` separator
    if (type === "address") {
        return `${explorer}party/${encodeURIComponent(address)}`;
    }

    // Transactions are addressed by update ID, optionally suffixed with an event
    // offset (e.g. `1220381cb6e3...:0`)
    return `${explorer}event/${address}`;
}

// // // //

/**
 * Generates a URL to a blockchain explorer based on the provided address, network, and type.
 *
 * This function takes an object with properties `address`, `networkSlug`, and `type`.
 * It returns a URL string pointing to the relevant page on a blockchain explorer.
 * If the address is null, or if the network slug doesn't correspond to a known network with an explorer,
 * the function returns null. The type can be 'address', 'tx' (transaction), or 'token',
 * which determines the path used in the explorer URL.
 *
 */
export function getBlockchainExplorerUrl(props: {
    address: null | string;
    networkSlug: null | string;
    type: "address" | "tx" | "token";
}) {
    const { address, networkSlug, type } = props;

    // Return null if there's no address or network present
    if (address === null || networkSlug === null) {
        return null;
    }

    // Get explorer base URL
    const network = networkSlug as Networks;
    const explorer = EXPLORERS[network];

    // Return null if there's no explorer URL defined
    if (!explorer) {
        return null;
    }

    if (network === Networks.arbitrum) {
        return getArbitrumExplorerUrl({
            address,
            type,
        });
    }

    if (network === Networks.algorand) {
        return getAlgorandExplorerUrl({
            address,
            type,
        });
    }

    if (network === Networks.avalanche || networkSlug === "avalanche") {
        return getAvalancheExplorerUrl({
            address,
            type,
        });
    }

    if (network === Networks.optimism) {
        return getOptimismExplorerUrl({
            address,
            type,
        });
    }

    if (network === Networks.noble) {
        return getNobleExplorerUrl({
            address,
            type,
        });
    }

    if (network === Networks.provenance) {
        return getProvenanceExplorerUrl({
            address,
            type,
        });
    }

    if (network === Networks.ink) {
        return getInkExplorerUrl({
            address,
            type,
        });
    }

    if (network === Networks.rootstock) {
        return getRootstockExplorerUrl({
            address,
            type,
        });
    }

    if (network === Networks.robinhoodChain) {
        return getRobinhoodChainExplorerUrl({
            address,
            type,
        });
    }

    if (network === Networks.polygon) {
        return getPolygonExplorerUrl({
            address,
            type,
        });
    }

    if (network === Networks.stellar) {
        return getStellarExplorerUrl({
            address,
            type,
        });
    }

    if (network === Networks.ethereum) {
        return getEthereumExplorerUrl({
            address,
            type,
        });
    }

    if (network === Networks.solana) {
        return getSolanaExplorerUrl({
            address,
            type,
        });
    }

    if (network === Networks.bnbChain) {
        return getBscExplorerUrl({
            address,
            type,
        });
    }

    if (network === Networks.tron) {
        return getTronExplorerUrl({
            address,
            type,
        });
    }

    if (network === Networks.xdc) {
        return getXdcExplorerUrl({
            address,
            type,
        });
    }

    if (network === Networks.canto) {
        return getCantoExplorerUrl({
            address,
            type,
        });
    }

    if (network === Networks.base) {
        return getBaseExplorerUrl({
            address,
            type,
        });
    }

    if (network === Networks.blast) {
        return getBlastExplorerUrl({
            address,
            type,
        });
    }

    if (network === Networks.near) {
        return getNearExplorerUrl({
            address,
            type,
        });
    }

    if (network === Networks.mantle) {
        return getMantleExplorerUrl({
            address,
            type,
        });
    }

    if (network === Networks.gnosis) {
        return getGnosisExplorerUrl({
            address,
            type,
        });
    }

    if (network === Networks.celo) {
        return getCeloExplorerUrl({
            address,
            type,
        });
    }

    if (network === Networks.aptos) {
        return getAptosExplorerUrl({
            address,
            type,
        });
    }

    if (network === Networks.sui) {
        return getSuiExplorerUrl({
            address,
            type,
        });
    }

    if (network === Networks.sei) {
        return getSeiExplorerUrl({
            address,
            type,
        });
    }

    if (network === Networks.zksyncEra) {
        return getZkSyncExplorerUrl({
            address,
            type,
        });
    }

    if (network === Networks.mantra) {
        return getMantraExplorerUrl({
            address,
            type,
        });
    }

    if (network === Networks.monad) {
        return getMonadExplorerUrl({
            address,
            type,
        });
    }

    if (network === Networks.xrpLedger) {
        return getXrpLedgerExplorerUrl({
            address,
            type,
        });
    }

    if (network === Networks.plume) {
        return getPlumeExplorerUrl({
            address,
            type,
        });
    }

    if (network === Networks.hedera) {
        return getHederaExplorerUrl({
            address,
            type,
        });
    }

    if (network === Networks.liquid) {
        return getLiquidExplorerUrl({
            address,
            type,
        });
    }

    if (network === Networks.hyperEVM) {
        return getHyperEvmExplorerUrl({
            address,
            type,
        });
    }

    if (network === Networks.plasma) {
        return getPlasmaExplorerUrl({
            address,
            type,
        });
    }

    if (network === Networks.injective) {
        return getInjectiveExplorerUrl({
            address,
            type,
        });
    }

    if (network === Networks.pharos) {
        return getPharosExplorerUrl({
            address,
            type,
        });
    }

    if (network === Networks.tempo) {
        return getTempoExplorerUrl({
            address,
            type,
        });
    }

    if (network === Networks.canton) {
        return getCantonExplorerUrl({
            address,
            type,
        });
    }

    return null;
}
